import React, { useState } from "react";
import "./Tooltip.scss";

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);
  const [tooltipCont, setTooltipCont] = useState(null);

  const showTooltip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 400);
  };

  const hideTooltip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  const getClass = () => {
    let adjustClass = "";
    if(tooltipCont){
        const width = window.innerWidth;
        const rect = tooltipCont.getBoundingClientRect();
        if(rect.left < 50){
            //elem is too left, move it to right
            adjustClass = "move-right"
        }
        else if(width - rect.right < 50){
            //elem is too right, move it to left
            adjustClass = "move-left"
        }
    }
    return adjustClass
}

  return (
    <div className={`tooltip-wrapper ${props.styleClasses || ''}`}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {props.children}
      {active && (props.content !== "") && (
        <div className={`tooltip-cont ${props.direction || "top"} ${props.tooltipClasses || ""} ${getClass()}`}
            ref={o => setTooltipCont(o)}
        >
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;